<template>
    <b-list-group>
        <b-list-group-item><router-link :to="{ name: 'SupervisorIndex' }">Clientes por marcas autorizadas</router-link></b-list-group-item>
        <b-list-group-item><router-link :to="{ name: 'SupervisorOffices' }">Oficinas de marcas autorizadas</router-link></b-list-group-item>
        <!-- <b-list-group-item><router-link :to="{ name: 'SupervisorContacts' }">Contacto</router-link></b-list-group-item>
        <b-list-group-item><router-link :to="{ name: 'SupervisorTestDrives' }">Test Drive</router-link></b-list-group-item> -->
    </b-list-group>
</template>
<script>
/*eslint-disable */
export default {
    name: 'Menu'
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Supervisor/Menu.vue